import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CustomersPriceTablesDto } from '@tiendanube/common';
import customerPriceTablesService from 'domains/Customers/CustomerPriceTables/customerPriceTablesService/customerPriceTablesService';
import { statusType, CustomerPriceTablesInterface } from './types';

const initialState: CustomerPriceTablesInterface = {
  priceTables: {
    data: [],
    status: statusType.idle,
  },
};

export const getCustomerPriceTables = createAsyncThunk<
  CustomersPriceTablesDto[],
  string
>(
  'customerPriceTables/getCustomerPriceTables',
  customerPriceTablesService.getCustomerPriceTables,
);

const customerPriceTables = createSlice({
  name: 'customerPriceTables',
  initialState,
  reducers: {
    clearCustomerPriceTables(state) {
      state.priceTables.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerPriceTables.pending, (state) => {
        state.priceTables.status = statusType.loading;
      })
      .addCase(getCustomerPriceTables.fulfilled, (state, action) => {
        state.priceTables.data = action.payload;
        state.priceTables.status = statusType.success;
      })
      .addCase(getCustomerPriceTables.rejected, (state) => {
        state.priceTables.status = statusType.error;
      });
  },
});

export const { reducer } = customerPriceTables;
export const { clearCustomerPriceTables } = customerPriceTables.actions;
